import { failure, inProgress, notAsked, RemoteData, success } from 'ngx-remotedata';
import { OrderCancelActions, OrderCancelActionTypes } from './actions';
import { ErrorWrapper, LoadOrder, LoadOrderActionTypes } from '@trade-platform/ui-shared';

export type OrderCancelState = RemoteData<null, ErrorWrapper>;
const initialState = notAsked<null, ErrorWrapper>();

export const orderCancelReducer = (
    state: OrderCancelState = initialState,
    action: OrderCancelActions | LoadOrder
): OrderCancelState => {
    switch (action.type) {
        case OrderCancelActionTypes.ORDER_CANCEL:
            return inProgress();
        case OrderCancelActionTypes.ORDER_CANCEL_SUCCESS:
            return success(null);
        case OrderCancelActionTypes.ORDER_CANCEL_FAILURE:
            return failure(action.payload.error);
        // A refusal belongs to the order it was attempted on. Without this the slice has no
        // path back to notAsked, so a failed cancel stayed in `failure` for the rest of the
        // session: every detail and process template renders its error banner on isFailure,
        // so the refusal followed the user to every order they opened next. Closing the
        // notification hid the banner without clearing the state, so it came back.
        //
        // Loading an order is when the previous order's refusal stops being true. Handling
        // LOAD_ORDER here rather than adding a reset action is deliberate: a reset action has
        // to be dispatched from every screen that loads an order, and a missed call site is
        // this same bug again.
        case LoadOrderActionTypes.LOAD_ORDER:
            return notAsked();
        default:
            return state;
    }
};
